{
  "splash": {
    "title": "Développé avec le support du Gouvernement du Canada"
  },
  "all-listings": {
    "disconnected": {
      "text": "Créé ton compte ou connecte-toi pour voir les ressources disponibles dans ACCÈS REFRAIN."
    },
    "needLogin": {
      "secondLine": "Créé ton compte ou connecte-toi pour voir les ressources disponibles dans ACCÈS REFRAIN."
    },
    "empty": {
      "offer": {
        "firstLine": "Débute ton aventure ici !",
        "primaryButtonText": "Publie une offre !",
        "secondLine": "Participe au catalogue en offrant des objets à prêter."
      }
    }
  },
  "billboard": {
    "unauthenticatedTitle": "Crée un compte ou connecte-toi",
    "unauthenticatedTitle_2": "pour voir les ressources disponibles dans ACCÈS REFRAIN."
  },
  "common": {
    "appName": "ACCÈS REFRAIN",
    "appDownloadPrompt": {
      "guest": "Tu aimes ce que tu vois? Retrouve ACCÈS REFRAIN sur ton téléphone et reçois les nouvelles disponibilités près de chez toi",
      "qrCodeAccessibilityLabel": "Code QR pour télécharger l’application ACCÈS REFRAIN"
    }
  },
  "contact-information": {
    "prompt": "Ajoute le code postal du festival afin de voir quels objets sont disponibles à proximité.",
    "title": "Ton adresse"
  },
  "contact-us": {
    "firstParagraph": "Le service aux membres d'ACCÈS REFRAIN est accessible par courriel et messagerie. Nous te répondrons le plus rapidement possible.",
    "faqLink": "https://lerefrain.com/fr/faq-acces-refrain",
    "chatPrompt": {
      "bugReport": "Salut ! 😊\n\nMerci de nous expliquer ce qui ne va pas.",
      "suggestion": "Salut ! 😊\n\nOn est toujours ouverts aux suggestions. Merci de nous aider à améliorer notre service.\n\nMerci !"
    }
  },
  "credentials": {
    "activationCodeFieldHelp": "Un code d'invitation est nécessaire afin d'utiliser ACCÈS REFRAIN. Pour en obtenir un, rends-toi sur <a>l'espace membre Refrain</a>.",
    "activationCodeFieldHelpLink": "https://lerefrain.com/fr/connexion"
  },
  "guidelines": {
    "fifthParagraph": "Ne pas utiliser ACCÈS REFRAIN pour vendre des objets."
  },
  "impact": {
    "levels": {
      "0": {
        "description-completed": "Rejoint ACCÈS REFRAIN",
        "title": "Explorateur"
      }
    }
  },
  "introModal": {
    "title": "Cher {{name}},",
    "first": "Bienvenue sur l’application de partage et découvre le <strong>vaste catalogue de ressources matérielles disponibles !</strong>",
    "second": "<strong>Partager est une preuve de confiance</strong> : plus tu prêtes, plus les autres auront envie de te prêter !",
    "third": "<strong>Sache que moins de 0,1% de tous les partages</strong> engendrent un bris. Et ce n’est pas de mauvaise foi. C’est juste normal quand les objets sont un peu plus utilisés."
  },
  "my-information": {
    "firstNameFieldLabel": "Nom du festival",
    "credentialInformationTitle": "Compte et sécurité",
    "personalInformationTitle": "Informations du profil"
  },
  "my-personal-information": {
    "firstNameFieldLabel": "Nom du festival",
    "firstNameFieldPlaceholder": "ex. Festival du Bon-Vent de Ste-Pépitte",
    "title": "Informations du profil"
  },
  "my-plan": {
    "businessPlan": {
      "firstParagraph": {
        "enterprise": "Ton abonnement à ACCÈS REFRAIN est une gracieuseté du Refrain."
      },
      "title": {
        "enterprise": "Abonnement ACCÈS REFRAIN"
      }
    },
    "refrainPlan": {
      "firstParagraph": "",
      "title": "Abonnement ACCÈS REFRAIN"
    },
    "noEnd": "Cet abonnement est valide tant que tu es membre du Refrain."
  },
  "new": {
    "itemInformationSection": {
      "nameFieldPlaceholder": "ex: Console de son",
      "descriptionFieldPlaceholder": {
        "offer": "Marque, dimensions, couleur, poids, état, année d’acquisition, conditions d’emprunt, spécificités de l’objet ...",
        "request": "Marque, dimensions, couleur, poids, état, année d’acquisition, conditions d’emprunt, spécificités de l’objet ..."
      }
    }
  },
  "notifications": {
    "introModal": {
      "intro": {
        "title": "Bienvenue dans le club",
        "body": "Découvre ACCÈS REFRAIN !"
      }
    },
    "welcome": "Bienvenue sur ACCÈS REFRAIN !",
    "welcomeMessage": "Merci de nous faire confiance.",
    "rate": {
      "borrower": {
        "message": "Ton avis est important pour nous et pour les autres membres d'ACCÈS REFRAIN."
      },
      "lender": {
        "message": "Ton avis est important pour nous et pour les autres membres d'ACCÈS REFRAIN."
      }
    }
  },
  "one-channel": {
    "levelModal": {
      "superSharer": {
        "message": "Tu as augmenté ton impact en réalisant 5 partages ! Tu accèdes maintenant au niveau ultime : <strong>Super Partageur</strong> et un exemple à suivre pour les autres membres d'ACCÈS REFRAIN.\n\nBravo! À chaque partage, tu grandis ton impact pour un avenir plus vert."
      }
    }
  },
  "one-listing": {
    "needFoundModal": {
      "step2": {
        "gotoSelectLender": "Le besoin a été comblé sur ACCÈS REFRAIN"
      }
    }
  },
  "personal-information": {
    "firstNameFieldLabel": "Nom du festival",
    "firstNameFieldPlaceholder": "ex. Festival du Bon-Vent de Ste-Pépitte",
    "pictureFieldSubtitle": "Cette image sera affichée dans tes annonces et ton profil.",
    "pictureFieldTitle": "Ajouter une image du logo du festival",
    "title": "Informations du profil"
  },
  "privacy": {
    "link1": "https://lerefrain.com/fr/acces-refrain-conditions-dutilisation",
    "link2": "https://lerefrain.com/fr/acces-refrain-politique-de-confidentialite",
    "line3": "d'ACCÈS REFRAIN."
  },
  "quick-new-thanks": {
    "bodyText": "Tu viens de contribuer à enrichir le catalogue d'<strong>ACCÈS REFRAIN</strong> ! \n\nTu peux modifier tes offres à tout moment dans ton centre de partage."
  },
  "ratings": {
    "notGreat": {
      "ctaButton": "Contacter ACCÈS REFRAIN"
    }
  },
  "tutorial": {
    "multipleOffers": {
      "step1": {
        "text": "En offrant tes objets, tu encourages même les festivals les plus timides à demander."
      }
    }
  },
  "presentPartageClub": {
    "community": {
      "headerText": "Accès Refrain, c'est l'application de <strong>partage d’équipements</strong> entre festivals",
      "footerText": "Ne vous <strong>limitez</strong> pas aux possessions de votre organisation"
    },
    "accessMore": {
      "headerText": "Sur Accès Refrain, tu accèdes à une <strong>abondance d’équipements</strong>.",
      "footerText": "Matériels, scènes, etc. : ici, vous trouvez <strong>vraiment tout.</strong>"
    },
    "offerMore": {
      "headerText": "Sur Accès Refrain, <strong>partager</strong> c’est <strong>aider</strong> d’autres festivals tout en <strong> optimisant ses ressources</strong>.",
      "footerText": "Faite <strong>profiter</strong> les autres festivals de vos équipements <strong>trop peu utilisés.</strong>"
    }
  }
}
